import { ROUTES as e, getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var n = {
	messages: {
		en: {
			staticPageApi: {
				createAlreadyExists: "The static page cannot be created because another static page with this name already exists.",
				updateAlreadyExists: "The static page cannot be updated because another static page with this name already exists.",
				created: "Static page created",
				updated: "Static page updated",
				notFound: "Static page not found",
				requiredFields: "The static page cannot be saved because mandatory information is missing."
			},
			staticPageList: {
				newButton: "New static page",
				name: "Search for title",
				deleteStaticPage: "Delete",
				dpAny: "All",
				brand: "Brand",
				loading: "Loading static page",
				headerTitle: "Title",
				headerCreatedAt: "Creation date",
				headerChangedAt: "Last modified date",
				counter: "Counter",
				dpEdit: "Edit",
				dpView: "View",
				messageDeleted: "Message deleted",
				errorOnDeleting: "Error deleting",
				createStaticPage: "Create static page",
				goToStaticPage: "Go to page"
			},
			staticPage: {
				staticPageLabel: "Static page",
				saveAndPublishButton: "Publish",
				newStaticPage: "New static page",
				messageDeleteStaticPage: "Delete static page",
				messageDeleteStaticPageTitle: "Are you sure you want to delete this static page?",
				deleteStaticPage: "Delete",
				messageDeleted: "Static page deleted",
				errorOnDeleting: "Error deleting the static page",
				errorFailedLoadedStaticPageWithId: "Error getting the static page",
				saveOffline: "Unpublish",
				messageConfirmTakeOffline: "Are you sure you want to unpublish this page?"
			},
			staticPageEdit: {
				basicsTab: "Basics",
				contentTab: "Content",
				codeContentTab: "Code",
				title: "Title",
				slug: "URL slug",
				pathConflictNotice: {
					template: "This path is in conflict with {pathType} path of another static page. Only {pathRoutable} static page will be reachable!",
					pathTypeCurrent: "the current",
					pathTypeOld: "an old",
					pathRoutableThis: "this",
					pathRoutableOther: "the other"
				},
				seoTitle: "SEO headline",
				seoDescription: "SEO description",
				isConsentRequired: "Activate CMP",
				content: "Content",
				codeContent: "Code",
				goToPage: "To page",
				editStaticPage: "Edit static",
				messageSaved: "New static page saved",
				messageUpdated: "Static page updated",
				showTitle: "Show title",
				isNoIndex: "Activate noIndex",
				isAdsEnabled: "Enable ads",
				isAdsEnabledHint: "CMP must be enabled to activate ads."
			}
		},
		de: {
			staticPageApi: {
				createAlreadyExists: "Die Statische Seite kann nicht erstellt werden, weil bereits eine Statische Seite mit diesem Namen existiert.",
				updateAlreadyExists: "Statische Seite kann nicht aktualisiert werden, weil bereits ein Statische Seite mit diesem Namen existiert.",
				created: "Statische Seite erstellt",
				updated: "Statische Seite aktualisiert",
				notFound: "Statische Seite nicht gefunden",
				requiredFields: "Die Statische Seite kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
			},
			staticPageList: {
				newButton: "Neue Statische Seite",
				name: "Suchen nach Titel",
				deleteStaticPage: "Löschen",
				dpAny: "Alle",
				brand: "Marke",
				loading: "Statische Seite wird geladen",
				headerTitle: "Titel",
				headerCreatedAt: "Erstellungsdatum",
				headerChangedAt: "Änderungsdatum (last modified)",
				counter: "Zähler",
				dpEdit: "Bearbeiten",
				dpView: "Anzeigen",
				messageDeleted: "Nachricht gelöscht",
				errorOnDeleting: "Fehler beim Löschen",
				createStaticPage: "Statische Seite erstellen",
				goToStaticPage: "Zur Seite"
			},
			staticPage: {
				staticPageLabel: "Statische Seite",
				saveAndPublishButton: "Veröffentlichen",
				newStaticPage: "Neue Statische Seite",
				messageDeleteStaticPage: "Statische Seite löschen",
				messageDeleteStaticPageTitle: "Willst du diese Statische Seite wirklich löschen?",
				deleteStaticPage: "Löschen",
				messageDeleted: "Statische Seite gelöscht",
				errorOnDeleting: "Fehler beim Löschen der Statischen Seite",
				errorFailedLoadedStaticPageWithId: "Fehler beim Abrufen der Statischen Seite",
				saveOffline: "Depublizieren",
				messageConfirmTakeOffline: "Willst du diese Statische Seite wirklich depublizieren?"
			},
			staticPageEdit: {
				basicsTab: "Basics",
				contentTab: "Inhalt",
				codeContentTab: "Code",
				title: "Titel",
				slug: "URL-Slug",
				pathConflictNotice: {
					template: "Dieser Pfad überschneidet sich mit {pathType} Pfad einer anderen statischen Seite. Nur {pathRoutable} statische Seite ist erreichbar!",
					pathTypeCurrent: "dem aktuellen",
					pathTypeOld: "einem alten",
					pathRoutableThis: "diese",
					pathRoutableOther: "die andere"
				},
				seoTitle: "SEO-Überschrift",
				seoDescription: "SEO-Beschreibung",
				isConsentRequired: "CMP aktivieren",
				content: "Inhalt",
				codeContent: "Code",
				goToPage: "Zur Seite",
				editStaticPage: "Statische Seite bearbeiten",
				messageSaved: "Neue Statische Seite gespeichert",
				messageUpdated: "Statische Seite aktualisiert",
				showTitle: "Titel anzeigen",
				isNoIndex: "NoIndex aktivieren",
				isAdsEnabled: "Werbung aktivieren",
				isAdsEnabledHint: "CMP muss aktiviert sein, um Werbung zu aktivieren."
			}
		}
	},
	routes: [{
		path: `/${e.staticPages.path}`,
		meta: { i18RouteTitleKey: e.staticPages.path },
		children: [
			{
				path: "",
				name: "static_page_list",
				component: () => import("./static-page-list.view-CNWf2oiF.js"),
				meta: { requiredRight: "static-pages:navigate" }
			},
			{
				path: "new",
				name: "static_page_new",
				component: () => import("./static-page-edit.view-CQ4YarrF.js"),
				props: () => ({
					title: t().t("staticPage.newStaticPage"),
					backRoute: "/static-page"
				}),
				meta: { requiredRight: ["static-pages:navigate"] }
			},
			{
				path: ":id",
				name: "static_page_detail",
				component: () => import("./static-page-edit.view-CQ4YarrF.js"),
				props: (e) => ({
					title: t().t("staticPageEdit.editStaticPage"),
					id: e.params.id,
					backRoute: "/static-page"
				}),
				meta: { requiredRight: ["static-pages:navigate"] }
			}
		]
	}]
};
//#endregion
export { n as staticPageModule };

//# sourceMappingURL=index.es.js.map